import { getPricingTierCtaHref } from "@/lib/urls";

export type RolePathId = "writer" | "studio" | "enterprise";

export type RolePath = {
  id: RolePathId;
  ctaHref: string;
  learnMoreHref: string;
};

export const rolePaths: RolePath[] = [
  {
    id: "writer",
    ctaHref: getPricingTierCtaHref("writer"),
    learnMoreHref: "/features/script",
  },
  {
    id: "studio",
    ctaHref: getPricingTierCtaHref("studio"),
    learnMoreHref: "/features/schedule",
  },
  {
    id: "enterprise",
    ctaHref: getPricingTierCtaHref("enterprise"),
    learnMoreHref: "/enterprise",
  },
];
